
const cardClasses =
  "flex flex-col justify-between items-start p-4 rounded-lg " +
  "bg-primary " +
  "text-white flex-1 basis-0 cursor-pointer";

const headerClasses =
  "flex items-center gap-2 font-heading text-sm font-medium " +
  "not-italic uppercase leading-5";

const valueClasses = "font-sans text-[calc(var(--spacing)*11)] font-bold leading-14";

const CompanyStatCard = ({icon, title, value, isLoading, onClick, className='' }) => {
  return (
    <div className={`${cardClasses} ${className}`} onClick={onClick}>
      <div className={headerClasses}>
        {icon}
        {title}
      </div>

      <div className={valueClasses}>{isLoading ? "—" : value}</div>
    </div>
  );
};

export default CompanyStatCard;
